import { Typography } from '@mui/material';
import { clsx } from 'clsx';
import React, { memo } from 'react';

import statusFirstStep from '~/assets/images/status-first-step.svg';
import statusFirstStepActive from '~/assets/images/status-first-step-active.svg';
import statusLastStep from '~/assets/images/status-last-step.svg';
import statusLastStepActive from '~/assets/images/status-last-step-active.svg';
import statusMiddleStep from '~/assets/images/status-middle-step.svg';
import statusMiddleStepActive from '~/assets/images/status-middle-step-active.svg';
import { CompanyStatus } from '~/types/models';

import styles from './styles.module.scss';

interface Props {
  activeStatus: CompanyStatus; // | 'calculating'; todo
}

const Component: React.FC<Props> = ({ activeStatus }) => {
  return (
    <div className={styles.container}>
      {activeStatus === 'pending' ? (
        <div className={styles.container__step}>
          <img alt="last step" src={statusLastStepActive} />
          <Typography
            className={clsx(
              styles['container__step__name'],
              styles['container__step__name--active'],
            )}
            variant="subtitle2"
          >
            Pending
          </Typography>
        </div>
      ) : (
        <>
          <div className={styles.container__step}>
            <img
              alt="first step"
              src={activeStatus === 'draft' ? statusFirstStepActive : statusFirstStep}
            />
            <Typography
              className={clsx(styles['container__step__name'], {
                [styles['container__step__name--active']]: activeStatus === 'draft',
              })}
              variant="subtitle2"
            >
              Draft
            </Typography>
          </div>
          {/* <div className={styles.container__step}>
            <img
              alt="middle step"
              src={activeStatus === 'calculating' ? statusMiddleStepActive : statusMiddleStep}
            />
            <Typography
              className={clsx(styles['container__step__name'], {
                [styles['container__step__name--active']]: activeStatus === 'calculating',
              })}
              variant="subtitle2"
            >
              Calculating
            </Typography>
          </div> */}
          <div className={styles.container__step}>
            <img
              alt="middle step"
              src={activeStatus === 'in_progress' ? statusMiddleStepActive : statusMiddleStep}
            />
            <Typography
              className={clsx(styles['container__step__name'], {
                [styles['container__step__name--active']]: activeStatus === 'in_progress',
              })}
              variant="subtitle2"
            >
              In Progress
            </Typography>
          </div>
          <div className={styles.container__step}>
            <img
              alt="last step"
              src={
                activeStatus === 'closed' || activeStatus === 'rejected'
                  ? statusLastStepActive
                  : statusLastStep
              }
            />
            <Typography
              className={clsx(styles['container__step__name'], {
                [styles['container__step__name--active']]:
                  activeStatus === 'closed' || activeStatus === 'rejected',
              })}
              variant="subtitle2"
            >
              {activeStatus === 'rejected' ? 'Rejected' : 'Accepted'}
            </Typography>
          </div>
        </>
      )}
    </div>
  );
};

export const StatusSteps = memo(Component);
